<template>
  <div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <b-tabs v-model="tabIndex" content-class class="navtab-bg" @activate-tab="selectedTab">
            <!-- Solicitations -->
            <b-tab title="Solicitações"
              :disabled="currentBtab === 'historic'"
            >
              <b-row class="d-flex align-items-start">
                <b-col cols="12" sm="12" md="7">
                    <div>
                      <div class="d-flex align-items-center">
                        <div v-if="getIsInternational" class="d-flex align-items-center gap-1 pr-3">
                          <span>Moeda&nbsp;</span>

                          <div>
                            <b-form-select
                              v-model="selectedCurrencySolicitation"
                              size="sm"
                              :options="optionsCurrency"
                              class="ml-1"
                            />
                          </div>
                        </div>

                        <span>Mostrar&nbsp;</span>
                        <div>
                          <b-form-select
                              v-model="perPage"
                              size="sm"
                              :options="pageOptions"
                            ></b-form-select>
                        </div>
                        <span>&nbsp;por página</span>
                      </div>
                      <div class="d-flex align-items-center mt-1">
                        <span class="mr-2">Período&nbsp;</span>
                        <date-range-picker
                          id="range"
                          ref="picker"
                          v-model="date"
                          
                          :locale-data="localeDate"
                          :show-week-numbers="false"
                          :show-dropdowns="true"
                          :auto-apply="false"
                          :ranges="dateRanges"
                          @update="debounce"
                        >
                          <template
                            v-if="date.startDate && date.endDate"
                            v-slot:input="picker"
                          >
                            {{ picker.startDate | date }} -
                            {{ picker.endDate | date }}
                          </template>
                          <template v-else v-slot:input>
                            Período
                          </template>
                        </date-range-picker>
                      </div>
                    </div>
                </b-col>
                
                 <!-- Search -->
                <b-col  md="5" sm="12"   class="d-flex justify-content-end align-items-center">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        v-model="sale_id"
                        type="search"
                        placeholder="ID Venda..."
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        v-model="email"
                        type="search"
                        placeholder="E-mail..."
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        v-model="client"
                        type="search"
                        placeholder="Cliente..."
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                  <div class="d-inline-flex align-self-start ml-2">
                    <b-button variant="success" size="sm" @click="onSearch">
                      <i class="fas fa-search"></i>
                    </b-button>
                  </div>
                </b-col>
              </b-row>

              <!-- Table -->
              <div class="row">
                <div class="col-12">
                  <div v-if="refundsGroup.length > 0 && !loading"
                    class="table-responsive mb-0"
                  >
                    <TableDefault
                      :header="header"
                      :data="refundsGroup"
                      :actions="actionsSolicitations"
                      :collapse="true"
                      :typetable="'solicitations'"
                      :route="'/reembolsos'"
                      :actionline="canRefundChangeStatus ? actionLine : null"
                      :currency-symbol="currencySymbolSolicitations"
                    />
                  </div>
                  <!-- Feedback Menssage -->
                  <div
                    v-else-if="
                      currentBtab === 'solicitations' ||
                      (currentBtab === '' && !loading)
                    "
                    class="row justify-content-center"
                  >
                    <div class="alert alert-primary" role="alert">
                      Sem solicitações de reembolso no momento.
                    </div>
                  </div>
                </div>
              </div>

              <!-- Loading -->
              <div v-if="loading" class="row justify-content-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>

              <!-- Pagination -->
              <div v-if="refundsGroup.length > 0" class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </b-tab>

            <!-- Historic -->
            <b-tab title="Histórico"
              :disabled="currentBtab === 'solicitations'"
            >
              <!-- Header -->
              <b-row class="d-flex align-items-start">
                <b-col cols="12" sm="12" md="7">
                  <div>
                    <div class="d-flex align-items-center">
                        <div v-if="getIsInternational" class="d-flex align-items-center gap-1 pr-3">
                          <span>Moeda&nbsp;</span>

                          <div>
                            <b-form-select
                              v-model="selectedCurrencyHistoric"
                              size="sm"
                              :options="optionsCurrency"
                              class="ml-1"
                            />
                          </div>
                        </div>
                        
                        <span>Mostrar&nbsp;</span>
                        <div>
                          <b-form-select
                              v-model="perPageHistoric"
                              size="sm"
                              :options="pageOptions"
                            ></b-form-select>
                        </div>
                        <span>&nbsp;por página</span>
                    </div>
                    <div class="d-flex align-items-center mt-1">
                        <span class="mr-2">Período&nbsp;</span>
                        <date-range-picker
                          id="range"
                          ref="picker"
                          v-model="date"
                          
                          :locale-data="localeDate"
                          :show-week-numbers="false"
                          :show-dropdowns="true"
                          :auto-apply="false"
                          :ranges="dateRanges"
                          @update="debounce"
                        >
                          <template
                            v-if="date.startDate && date.endDate"
                            v-slot:input="picker"
                          >
                            {{ picker.startDate | date }} -
                            {{ picker.endDate | date }}
                          </template>
                          <template v-else v-slot:input>
                            Período
                          </template>
                        </date-range-picker>
                    </div>
                  </div>
                </b-col>
                
                 <!-- Search -->
                <b-col  md="5" sm="12"   class="d-flex justify-content-end align-items-center">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                    
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        v-model="sale_id_historic"
                        type="search"
                        placeholder="ID Venda..."
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        v-model="email_historic"
                        type="search"
                        placeholder="E-mail..."
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        v-model="client_historic"
                        type="search"
                        placeholder="Cliente..."
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                  <div class="d-inline-flex align-self-start ml-2">
                    <b-button variant="success" size="sm" @click="onSearchHistoric">
                      <i class="fas fa-search"></i>
                    </b-button>
                  </div>
                </b-col>
              </b-row>

              <!-- Table -->
              <div class="row">
                <div class="col-12">
                  <div v-if="refundsGroup.length > 0 && !loading"
                    class="table-responsive mb-0"
                  >
                    <TableDefault
                      :header="header"
                      :data="refundsGroup"
                      :actions="actionsHistoric"
                      :collapse="true"
                      :typetable="'historic'"
                      :route="'/reembolsos'"
                      :actionline="canRefundChangeStatus ? actionLine : null"
                      :currency-symbol="currencySymbolHistoric"
                    />
                  </div>
                  <!-- Feedback Menssage -->
                  <div v-else-if="!loading"
                    class="row justify-content-center"
                  >
                    <div class="alert alert-primary" role="alert">
                      Sem solicitações de reembolso no momento.
                    </div>
                  </div>
                </div>
              </div>

              <!-- Loading -->
              <div v-if="loading" class="row justify-content-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>

              <!-- Pagination -->
              <div v-if="refundsGroup.length > 0" class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPageHistoric"
                        :total-rows="totalRowsHistoric"
                        :per-page="perPageHistoric"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <ModalBankAccountGroup v-if="solicitations.length > 0"
      :solicitations="solicitations"
      @refund-group="refundGroup($event)"
      @submit="refund"
    />
    <BankAccount @submit="refund" />
  </div>
</template>

<script>
import Vue from 'vue'
import appConfig from '@src/app.config'
import PageHeader from '@components/page-header'
import RefundService from '@services/resources/RefundService'
import RefundGroupService from '@services/resources/RefundGroupService'
import BankAccount from './bankAccount'
import Money from '@src/mixins/money'
import TableDefault from '@components/TableDefault'
import ModalBankAccountGroup from './ModalBankAccountGroup.vue'
import _ from 'lodash'
import DateRangePicker from 'vue2-daterange-picker'
import moment from 'moment'
// import SelectCurrency from '@components/SelectCurrency'
import { mapGetters } from 'vuex';

var service = RefundService.build()
var groupService = RefundGroupService.build()

export default {
  name: "RefundsList",
  page: {
    title: 'Solicitações de reembolsos',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    PageHeader,
    BankAccount,
    TableDefault,
    ModalBankAccountGroup,
    DateRangePicker,
    // SelectCurrency
  },
  mixins: [Money],
  data() {
    return {
      date: {
        startDate: moment().startOf('week').format('YYYY-MM-DD'),
        endDate: moment().endOf('week').format('YYYY-MM-DD'),  
      },
      localeDate: {
        direction: 'ltr',
        format: 'mm/dd/yyyy',
        separator: ' - ',
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        firstDay: 0,
      },
      actionsSolicitations: [
        {
          variant: 'success',
          func: this.accepted,
          classButton: 'fas fa-check',
          tooltipText: "Aceitar reembolso"
        },
        {
          variant: 'danger',
          func: this.deny,
          classButton: 'fas fa-times',
          tooltipText: "Recusar reembolso"
        },
      ],
      actionsHistoric: [],
      actionLine: {
        func: this.acceptRefundGroup,
      },
      currencyHistoric: {
        id: 1,
        name: "Real Brasileiro",
        currency: "BRL",
        currency_symbol: "R$",
      },
      currencySolicitations: {
        id: 1,
        name: "Real Brasileiro",
        currency: "BRL",
        currency_symbol: "R$",
      },
      currencySymbolSolicitations: "R$",
      currencySymbolHistoric: "R$",
      currentBtab: '',
      currentPage: 1,
      currentPageHistoric: 1,
      filter: '',
      filterOn: [],
      header: [
        { label: 'Vendedor', search: { value: 'value', order: '' } },
        { label: 'Nome', search: { value: 'value', order: '' } },
        { label: 'E-mail', search: { value: 'value', order: '' } },
        { label: 'Celular', search: { value: 'value', order: '' } },
        { label: 'Product', search: { value: 'value', order: '' } },
        { label: 'Valor', search: { value: 'value', order: '' } },
        { label: 'ID Venda', search: { value: 'value', order: '' } },
        { label: 'Método', search: { value: 'value', order: '' } },
        { label: 'Moeda Local', search: { value: 'value', order: '' } },
        { label: 'Moeda Base', search: { value: 'value', order: '' } },
        { label: 'Data', search: { value: 'value', order: '' } },
        { label: 'Ações' },
      ],
      selectedCurrencySolicitation: 1,
      selectedCurrencyHistoric: 1,
      optionsCurrency: [
        { value: 1, text: 'BRL' },
        { value: 2, text: 'USD' },
        { value: 3, text: 'EUR'},
      ],
      lineSelected: {},
      items: [
        {
          text: 'Início',
          href: '/',
        },
        {
          text: 'Solicitações de reembolsos',
          active: true,
        },
      ],
      loading: true,
      perPage: 10,
      perPageHistoric: 10,
      pageOptions: [10,20, 50, 100],
      refunds: [],
      refundsGroup: [],
      solicitation: {},
      solicitations: [],
      sortBy: 'name',
      sortDesc: false,
      statusTable: {
        REQUESTED: 'Solicitado',
        ACCEPTED: 'Aceitado',
        DENIED: 'Recusado',
      },
      tabIndex: 0,
      title: 'Solicitações de reembolsos',
      totalRows: 1,
      totalRowsHistoric: 1,
      sale_id: null,
      email: null,
      client: null,
      sale_id_historic: null,
      email_historic: null,
      client_historic: null,
      filters: {},
    }
  },
  computed: {
    ...mapGetters({
      getIsInternational: 'getIsInternational',
    }),
    dateRanges() {
      let today = new Date()
      today.setHours(0, 0, 0, 0)

      let yesterday = new Date()
      yesterday.setDate(today.getDate() - 1)
      yesterday.setHours(0, 0, 0, 0)

      let lastWeek = new Date()
      lastWeek.setDate(today.getDate() - 7)
      lastWeek.setHours(0, 0, 0, 0)

      return {
        Hoje: [today, today],
        Ontem: [yesterday, yesterday],
        'Última semana': [lastWeek, today],
        'Este mês': [
          new Date(today.getFullYear(), today.getMonth(), 1),
          new Date(today.getFullYear(), today.getMonth(), 30),
        ],
        'Este ano': [
          new Date(today.getFullYear(), 0, 1),
          new Date(today.getFullYear(), 11, 31),
        ],
        'Último mês': [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          new Date(today.getFullYear(), today.getMonth(), 0),
        ],
      }
    },
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    },
    canRefundChangeStatus() {
      return this.$canAction('refund_change_status_button', 'editor')
    },
  },
  watch: {
    currentPage() {
      this.fetchSolicitations()
    },
    perPage() {
      this.fetchSolicitations()
    },
    currentPageHistoric() {
      this.fetchHistoric()
    },
    perPageHistoric() {
      this.fetchHistoric()
    },
    filter() {
      this.debounce()
    },
    selectedCurrencySolicitation() {
      this.currentPage = 1
      this.fetchSolicitations()
    },
    selectedCurrencyHistoric() {
      this.currentPageHistoric = 1
      this.fetchHistoric()
    }
  },
  mounted() {
    if(this.isHeaven) {
      this.currencyHistoric = {
        id: 2,
        currency: "USD",
        currency_symbol: "$",
      }
      this.currencySolicitations = {
        id: 2,
        currency: "USD",
        currency_symbol: "$",
      }
      this.currencySymbolSolicitations = '$'
      this.currencySymbolHistoric = '$'
    }
    this.fetchSolicitations()
  },
  methods: {
    async onSearch() {
      this.currentPage = 1
      await this.debounce()
    },
    async onSearchHistoric() {
      this.currentPageHistoric = 1
      await this.debounceHistoric()
    },
    debounce: _.debounce(async function () {
      await this.fetchSolicitations()
    }, 500),
    debounceHistoric: _.debounce(async function () {
      await this.fetchHistoric()
    }, 500),
    clearData(refundSolicitations) {
      refundSolicitations.forEach((refundSolicitation) => {
        refundSolicitation.bank_code = null
        refundSolicitation.agency_number = null
        refundSolicitation.agency_dv = null
        refundSolicitation.account_number = null
        refundSolicitation.account_dv = null
        refundSolicitation.name = null
        refundSolicitation.document_number = null
      })
    },
    getTickets(refundSolicitations) {
      return refundSolicitations.find(refundSolicitation => refundSolicitation.sale.method === 'BOLETO')
    },
    async refundGroup(refundSolicitations) {
      if (!this.ensureCanRefundChange()) {
        return;
      }
      const promise = refundSolicitations.map(async (refundSolicitation) => {
        await this.refundItemsOfGroup(refundSolicitation)
      })
      await Promise.all(promise)
      await this.clearData(refundSolicitations)
      await this.fetchSolicitations()
    },
    async refundItemsOfGroup(refundSolicitation) {
      if (!this.ensureCanRefundChange()) {
        return;
      }
      let data = {
        id: refundSolicitation.id,
        status: 'ACCEPTED',
        transaction_id: refundSolicitation.sale.transaction_id,
      }
      const account = {
        bank_code: refundSolicitation.bank_code,
        agency_number: refundSolicitation.agency_number,
        agency_dv: refundSolicitation.agency_dv,
        account_number: refundSolicitation.account_number,
        account_dv: refundSolicitation.agency_dv,
        name: refundSolicitation.name,
        document_number: refundSolicitation.document_number,
      }

      Object.assign(data, account)

      await service
        .update(data)
        .then(async() => {
          await this.fetchSolicitations()
        })
        .catch(err => console.error(err))
    },
    async fetchSolicitations(status = ['REQUESTED'], tab) {
      this.currentBtab = tab
      this.loading = true
      this.refunds = []

      let data = {
        per_page: this.perPage,
        page: this.currentPage,
        status,
        currency: this.isHeaven ? 'USD' : 'BRL',
        date_start: this.date.startDate
          ? moment(this.date.startDate).format('YYYY-MM-DD')
          : null,
        date_end: this.date.endDate
          ? moment(this.date.endDate).format('YYYY-MM-DD')
          : null,
          coin_id: this.selectedCurrencySolicitation,
      }

      if (this.sale_id) data.sale_id = this.sale_id
      if (this.email) data.email = this.email
      if (this.client) data.client = this.client

      await groupService
        .search(data)
        .then(async resp => {
          this.refunds = resp.data
          await this.dataTableSolicitations()
          this.totalRows = resp.total
          this.currentBtab = ''
        })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false })
    },
    async fetchHistoric(status = ['ACCEPTED', 'DENIED'], tab) {
      this.currentBtab = tab
      this.loading = true
      this.refunds = []

      let data = {
        per_page: this.perPageHistoric,
        page: this.currentPageHistoric,
        status: status,
        currency: this.isHeaven ? 'USD' : 'BRL',
        coin_id: this.selectedCurrencyHistoric,
      }

      if (this.sale_id_historic) data.sale_id = this.sale_id_historic
      if (this.email_historic) data.email = this.email_historic
      if (this.client_historic) data.client = this.client_historic

      await groupService
        .search(data)
        .then(async resp => {
          this.refunds = resp.data
          this.dataTableSolicitations()
          this.totalRowsHistoric = resp.total
          this.currentBtab = ''
        })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false })
    },
    async refund(account = {}) {
      if (!this.ensureCanRefundChange()) {
        return;
      }
      let data = {
        id: this.solicitation.id,
        status: 'ACCEPTED',
        transaction_id: this.solicitation.sale.transaction_id
      }

      Object.assign(data, account)

      await service
        .update(data)
        .then(async() => {
          await this.fetchSolicitations()
        })
        .catch(err => console.error(err))
    },
    dataTableSolicitations() {
      try {
        const data = this.refunds

        data.forEach((item) => {
          item.items = item.refund_solicitations.map((element) => {
            return {
              vendedor: (element.sale && element.sale.seller && element.sale.seller.name) || '-',
              nome: (element.sale && element.sale.client && element.sale.client.name) || '-',
              email: (element.sale && element.sale.client && element.sale.client.email) || '-',
              celular: (element.sale && element.sale.client && element.sale.client.cellphone) || '-',
              product: (element.sale && element.sale.product && element.sale.product.name) || '-',
              sale_id: (element.sale && element.sale.id) || '-',
              valor: `${
                element.sale.base_currency.currency_symbol ?  element.sale.base_currency.currency_symbol : '-' 
              } ${this.formatMoney(element.sale.amount)}` || '-',
              metodo: element.sale.method || '-',
              local_currency: `${
                element.sale.local_currency ? element.sale.local_currency.currency : '-'
              }` || '-',
              base_currency: `${
                element.sale.base_currency ? element.sale.base_currency.currency : '-'
              }` || '-',
              data: this.$datetime(element.created_at) || '-',
              status: this.statusTable[element.status] || '-'
            }
          })
        })
        this.refundsGroup = data
      } catch (err) { console.error(err) }
    },
    async updateCoinSolicitations(currency) {
      if(this.tabIndex === 0) {
        this.currencySolicitations = currency
        this.currencySymbolSolicitations = currency.currency_symbol
        await this.fetchSolicitations(['REQUESTED'], 'solicitations')
      }
    },
    async updateCoinHistoric(currency) {
      if(this.tabIndex === 1) {
        this.currencyHistoric = currency;
        this.currencySymbolHistoric = currency.currency_symbol;
        await this.fetchHistoric(['ACCEPTED', 'DENIED'], 'historic');
      }
    },
    async selectedTab(newTab) {
      if(newTab === 0) {
        await this.fetchSolicitations(['REQUESTED'], 'solicitations')
      } else {
        await this.fetchHistoric(['ACCEPTED', 'DENIED'], 'historic')
      }
    },
    async acceptRefundGroup(lineTable) {
      if (!this.ensureCanRefundChange()) {
        return;
      }
      if(lineTable.refund_solicitations) if(lineTable.refund_solicitations.length > 0) {
        Vue.swal({
          title: 'Realizar reembolso',
          text: 'Tem certeza que deseja aceitar essas solicitações de reembolso?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancelar',
          confirmButtonClass: 'btn btn-warning mt-2 mr-2',
          cancelButtonClass: 'btn btn-info mt-2',
          buttonsStyling: false,
        }).then(async(result) => {
          if (result.value) {
            const hasTicket = await this.getTickets(lineTable.refund_solicitations)
            if (hasTicket) {
              this.solicitations = lineTable.refund_solicitations
              this.$bvModal.show('bank-account-group')
            }
            await this.refundGroup(lineTable.refund_solicitations)
          }
        })
      } else {
        Vue.swal({
          title: 'Nenhum reembolso listado',
          text: 'Não foram encontrados solicitações de reembolso nesse grupo.',
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Ok',
          confirmButtonClass: 'btn btn-warning',
          buttonsStyling: false,
        })
      }
    },
    async accepted(lineTable) {
      if (!this.ensureCanRefundChange()) {
        return;
      }
      let itemRefund = null
      this.refundsGroup.forEach((item) => {
        item.refund_solicitations.forEach((element) => {
          if (
            this.$datetime(element.created_at) === lineTable.data &&
            `${element.sale.base_currency.currency_symbol} ${this.formatMoney(element.sale.amount)}` === lineTable.valor
          ) {
            itemRefund = element
          }
        })
      })
      Vue.swal({
        title: 'Aceitar reembolso',
        text: 'Tem certeza que deseja aceitar essa solicitação de reembolso?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      })
      .then(async(result) => {
        if (result.value) {
          this.solicitation = itemRefund

          if (itemRefund.sale.method === 'BOLETO') {
            this.$bvModal.show('bank-account')
            return
          }

          await this.refund();
        }
      })
      .catch(err => console.error(err))
    },
    async deny(lineTable) {
      if (!this.ensureCanRefundChange()) {
        return;
      }
      let itemRefund = null
      this.refundsGroup.forEach((item) => {
        item.refund_solicitations.forEach((element) => {
          if (
            this.$datetime(element.created_at) === lineTable.data &&
            `${element.sale.base_currency.currency_symbol} ${this.formatMoney(element.sale.amount)}` === lineTable.valor
          ) {
            itemRefund = element
          }
        })
      })
      Vue.swal({
        title: 'Recusar reembolso',
        text: 'Tem certeza que deseja recusar essa solicitação de reembolso?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then(async(result) => {
        if (result.value) {
          let data = {
            id: itemRefund.id,
            status: 'DENIED',
          }

          await service
            .update(data)
            .then(async(resp) => {
              await this.fetchSolicitations()
            })
            .catch(err => console.error(err))
        }
      })
    },
    ensureCanRefundChange() {
      if (this.canRefundChangeStatus) return true;
      Vue.swal({
        title: 'Permissão insuficiente',
        text: 'Você não tem permissão para alterar o status de reembolso.',
        type: 'warning',
        confirmButtonText: 'Ok',
        confirmButtonClass: 'btn btn-warning',
        buttonsStyling: false,
      });
      return false;
    },
    // ---------------------------------
  },
}
</script>

<style lang="scss" scoped>
.row.justify-content-center {
  margin-top: 20px !important;
}
</style>
